import { hasPermission } from '@/Utils/permissions'

export default {
  methods: {
    hasSubscription: () => (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'))?.facility?.subscription !== 'basic'),
    checkProviderType: (type) => (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'))?.facility?.facility_type?.toLowerCase() === type?.toLowerCase()) || type === 'all',
    hasPer: (permission) => hasPermission(permission),
    // Whether the route (name or location) is open to the account, by its `meta.permission`.
    canOpenRoute (to) {
      return hasPermission(this.$router.resolve(typeof to === 'string' ? { name: to } : to).route.meta.permission)
    },
    ifBranchesAccess: () => (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'))?.facility?.branches_access)
  }
}
